// Prefixes align with what's used in the Conversions API, defined in:
// https://github.com/alltrails/lambda-amplitude-kinesis-integrations/blob/alpha/packages/handler/src/handler/params.py
// Using identifiers which are aligned with the Conversions APIs is important for the deduplication of events.
const PURCHASE_EVENT_ID_PREFIX = 'subscription-psp-se';
const TRIAL_START_EVENT_ID_PREFIX = 'freetrial-pfts-se';
const SIGNUP_EVENT_ID_PREFIX = 'signup-ra';

export const getPurchaseEventId = (subscriptionEventId: number) => {
  return `${PURCHASE_EVENT_ID_PREFIX}-${subscriptionEventId}`;
};

export const getTrialStartEventId = (subscriptionEventId: number) => {
  return `${TRIAL_START_EVENT_ID_PREFIX}-${subscriptionEventId}`;
};

export const getSignupEventId = (userId: number) => {
  return `${SIGNUP_EVENT_ID_PREFIX}-${userId}`;
};
